<template >
<div >
    <v-layout row wrap>
        
    </v-layout>
    <v-container grid-list-xs>
        <v-row>
            <v-col sm="8" cols="12"  >
                <v-layout column>
                    <div  v-for="(item, index) in p_services.list" :key="index">
                        <v-card class="mb-2 pr-2" color="b1" tile="" hover="" flat="" :to="'/services/'+item.key">
                            <v-row > 
                                <v-col sm="4" cols="12">
                                    <div v-if="!item.image">
                                        <v-img
                                            :src="not.img"
                                            :lazy-src="not.imgLazy"
                                            aspect-ratio="1.5"
                                            class="grey lighten-2"/>   
                                    </div>
                                    <div v-else>
                                        <v-img
                                            :src="item.image.link"
                                            :lazy-src="not.imgLazy"
                                            aspect-ratio="1.5"
                                            class="grey lighten-2"/>   
                                    </div>
                                </v-col>
                                <v-col sm="8" cols="12">
                                    <v-layout column="" fill-height> 
                                        <div class="not-f7 font-weight-bold pb-2">{{item.name}}</div>
                                        <div> 
                                            <div v-if="not.size(item.desc)<150">{{item.desc}}</div>
                                            <div v-else>{{item.desc.substring(0,150)+"..."}}</div>
                                        </div> 
                                        <v-spacer></v-spacer>
                                        <v-divider></v-divider> 
                                        <div class="mt-1">
                                            <v-toolbar height="30"  tile="" color="b1" flat="">
                                                <v-spacer></v-spacer>
                                                <v-btn class="ma-0" :to="'/programs/'+item.key" small="" text rounded="" outlined="" color="primary">Read More</v-btn>
                                            </v-toolbar>
                                        </div>
                                    </v-layout>
                                </v-col> 
                            </v-row> 
                        </v-card>
                    </div>
                </v-layout>
            </v-col>
            <v-col sm="4">
                <v-layout column="" justify-center=""> 
                    <div class="pt-2 mr-1">
                        <v-text-field background-color="primary lighten-4" 
                            v-model="nameSearch"
                            placeholder="Type and search"
                            id="search"
                            rounded=""  
                            outlined="" 
                            label="Search"
                            append-icon="search"
                        ></v-text-field>
                    </div>

                    <v-card class="mx-5">
                        <v-card-title class="primary white--text">
                            Community
                        </v-card-title>
                        <v-card-text>
                            <v-list single-line dense=""  >
                                <div v-for="(com, index) in not.ARRAY_F(communities,10)" :key="index">
                                    <v-list-item :to="'/about/communities/'+com.name">{{com.name}}</v-list-item>
                                    <v-divider></v-divider> 
                                </div>
                            </v-list>
                            <v-layout justify-center="">
                                <v-btn  outlined="" to="/about/communities" color="primary">view all</v-btn>
                            </v-layout>
                        </v-card-text>
                    </v-card> 
                </v-layout>
            </v-col>
        </v-row>
        <br>
        <v-divider></v-divider>
        <div class="px-5">
            <v-pagination
                v-model="page_current"
                class="mt-4"
                :length="p_services?p_services.pages:0"/> 
        </div>
    </v-container>
   
</div>
</template>

<script>
     let pageName = "Services"
    export default{
        name: pageName, 
        props: ["not"], 
        data: () => ({
            page_current:1,
            page_size:10,
            page_show:false, 
            playing:false,
            nameSearch:null,
            images:[
                {src:'/images/teresian/t21.JPG',local:true},  
            ],
        }), 
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notImages:this.images,
                notText:false,
                notIndicators:true,
                notHeight:350
            })
        },
        computed: {
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
             
            services(){
                let nameSearch = this.nameSearch
                let services = this.$store.getters.getServices
                 
                return services.filter(ss=>{
                    let name = this.not.TEXT_UP(ss.name)
                    let nameSearch = this.not.TEXT_UP(this.nameSearch)
                    let index = 1
                    if (nameSearch) {
                        index = name.indexOf(nameSearch)
                    }
                    return index != -1
                })
            }, 
            p_services(){
                if (!this.services) {
                    return []
                }
                let list = [...this.services]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
            sisters(){
                let sisters = this.$store.getters.getSisters

                //Search through  sisters
                return sisters
            }, 
            communities(){
                let sisters = this.sisters 
                let communities = this.not.JOIN_COMMUNITIES(sisters) 

                //Search through  sisters
                return communities.filter(mm=>{
                    let name = this.not.TEXT_UP(mm.name) 
                    let nameSearch = this.not.TEXT_UP(this.nameSearch1)
                    let index = 1
                    if (nameSearch) {
                        index = name.indexOf(nameSearch)
                    }
                    return index != -1
                })
            },
        }, 
        methods:{
            clicked(){

            }
            
        }, 
    } 
    
</script> 
